module.exports = __webpack_public_path__ + "static/sav.banner-mosaic-pedras-de-zirconia-c52e8b32de4ac47420296a5de58be6a1.jpg";